module.exports = __webpack_public_path__ + "img/lu.61d86a4e.svg";